import {useCallback, useState} from 'react';
import {v4 as uuidV4} from 'uuid';

import {Subscriptions} from '~/modules/api';
import {useCreateDiscountCodeMutation} from '~/store/rtkQuery';

export const CreateDiscountCodeModal = ({
  discountTypes,
  onComplete,
  onCancel,
}: {
  discountTypes: Array<{discountType: string; audience: string; title: string}>;
  onComplete: () => void;
  onCancel: () => void;
}) => {
  const [createDiscountCode, {error}] = useCreateDiscountCodeMutation();

  const [newId] = useState(uuidV4());

  const [code, setCode] = useState('');
  const [discountType, setDiscountType] = useState('');
  const [active, setActive] = useState(false);

  const onCreateCode = useCallback(async () => {
    if (!discountType || !code) {
      return;
    }

    const create: Subscriptions.CreateDiscountCodeRequest = {
      id: newId,
      code,
      discountType,
      active,
    };
    const response = await createDiscountCode(create);

    if (!('error' in response)) {
      onComplete();
    }
  }, [newId, code, active, discountType, createDiscountCode, onComplete]);

  return (
    <dialog className="modal modal-open">
      <div className="modal-box w-6/12 max-w-4xl">
        <div className="text-2xl">Create discount code</div>

        <div className="py-4">
          <div className="form-control">
            <label className="label">
              <span className="label-text">Code</span>
              <input
                className="input input-bordered"
                type="text"
                value={code}
                onChange={e => setCode(e.target.value)}
              />
            </label>
          </div>
          <div className="form-control">
            <label className="label">
              <span className="label-text">Discount Type</span>
              <select
                className="select select-bordered"
                value={discountType}
                onChange={e => setDiscountType(e.target.value)}>
                <option value="">--- select type ---</option>
                {discountTypes.map(({discountType, audience, title}) => (
                  <option key={discountType} value={discountType}>
                    {discountType} - {title} ({audience})
                  </option>
                ))}
              </select>
            </label>
          </div>
          <div className="form-control py-4">
            <label className="label">
              <span className="label-text">Code Active</span>
              <input
                type="checkbox"
                checked={active}
                className="checkbox checkbox-primary"
                onChange={e => setActive(e.target.checked)}
              />
            </label>
          </div>
        </div>

        {!!error && (
          <div role="alert" className="alert alert-error">
            <span>{error.message}</span>
          </div>
        )}

        <div className="modal-action">
          <button className="btn" onClick={onCancel}>
            Close
          </button>
          <button
            className="btn btn-primary"
            onClick={onCreateCode}
            disabled={!discountType || !code}>
            Save
          </button>
        </div>
      </div>
    </dialog>
  );
};
